export function extractFieldErrors(errorResponse: any) {
  if (
    errorResponse?.data?.error?.details?.errors &&
    Array.isArray(errorResponse.data.error.details.errors)
  ) {
    return errorResponse.data.error.details.errors.map((err: any) => ({
      field: err.path?.join(".") || "Unknown field",
      message: err.message,
    }));
  }
  return [
    { field: "Error", message: "One of the unique fields already exists" },
  ];
}
